import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { CUSTOM_ATTRIBUTE_VALUES } from 'graphql/queries';
import getCategoryId from 'utils/getCategoryId';

export default function useCustomFilterValues() {
  const router = useRouter();

  const lang = router.locale ? router.locale : 'et';

  const query = router.query?.kategooria;
  const urlKey = query?.slice().pop();

  const categoryId = getCategoryId(urlKey);

  const { data } = useQuery(CUSTOM_ATTRIBUTE_VALUES, {
    variables: { id: categoryId },
    context: { fetchOptions: { method: 'GET' } , headers: {store: lang}}
  });
  const aggregations = data?.products.aggregations;

  return aggregations;
}
